import { page, getById } from '@/api/business/payAccount'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(page, getById)
